import React, { useState } from 'react';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { Form, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { AuthWrapper } from '../style';
import Heading from '../../../../../components/heading/heading';
import { forgotPassword } from '../../../../../redux/authentication/actionCreator';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    values: null,
  });
  const handleSubmit = values => {
    setState({ ...state, values });
    values.phone = `60${values.phone}`;
    dispatch(forgotPassword(values));
  };
  const isLoading = useSelector(state => state.auth.loading);

  return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form name="forgotPass" onFinish={handleSubmit} layout="vertical">
          <Heading as="h5">Tetap Kata Laluan</Heading>
          <p className="forgot-text">Sila sahkan nombor telefon anda untuk tetapan kata laluan baru</p>
          <Form.Item
            name="phone"
            rules={[
              { message: 'Sila masukkan nombor telefon anda!', required: true },
              { pattern: /^[0-9]{9,11}$/, message: 'Sila isikan nombor telefon yang sah' },
            ]}
            label="Nombor Telefon Bimbit"
          >
            <Input type="number" addonBefore={'+60'} placeholder="1023456489" />
          </Form.Item>
          <Form.Item>
            <Button
              style={{ backgroundColor: '#EA0029', border: '#EA0029' }}
              className="btn-reset"
              htmlType="submit"
              type="primary"
              size="large"
            >
              {isLoading ? 'Loading...' : 'SAHKAN'}
            </Button>
          </Form.Item>
          <p className="return-text">
            Kembali ke{' '}
            <NavLink style={{ color: 'red' }} to="/">
              Log Masuk
            </NavLink>
          </p>
        </Form>
      </div>
    </AuthWrapper>
  );
};

export default ForgotPassword;
